import React, { useState } from 'react';
import './Testimonials.css';

interface Testimonial {
  text: string;
  author?: string;
}

const Testimonials: React.FC = () => {
  const [selectedTestimonial, setSelectedTestimonial] = useState<Testimonial | null>(null);

  const testimonials: Testimonial[] = [
    {
      text: "Roxanne has been tutoring my daughter for nearly two years, and the progress we've seen has been truly remarkable. When we first started, my daughter was significantly behind in her reading level—about two full grade levels—due to the challenges brought on by the pandemic. She struggled with basic reading skills, including sight words, and lacked confidence in her ability to read. From the beginning, Roxanne showed incredible patience and dedication. She made reading fun and engaging, which helped my daughter feel more comfortable and motivated. We started with virtual sessions, which were effective, but the transition to in-person tutoring over the past few months has made an even bigger impact. My daughter genuinely enjoys her time with Roxanne and looks forward to their sessions. One of the most effective strategies Roxanne used was reading novels together and taking turns. This approach helped my daughter become more confident reading aloud and improved her fluency. Over the summer, Roxanne encouraged her to read books independently and guided her through writing summaries, which strengthened her comprehension and writing skills. Thanks to Roxanne's thoughtful approach and unwavering support, my daughter is now nearly at grade level in reading. We are so grateful for Roxanne's help and highly recommend her to any family looking for a compassionate and effective tutor.",
      author: "P. Miller"
    },
    {
      text: "My son has been working on reading and writing with Roxanne for a few months both on zoom and in person. He really enjoys their sessions and has started to make improvements in both reading and writing. I would highly recommend Roxanne to anyone who is looking for a tutor. Her positive energy and professionalism make her easy to work with.",
      author: "V. Brand"
    },
    {
      text: "Roxanne has been an exceptional partner in helping our son, John-François. She blends deep expertise in executive function and ADHD-friendly strategies with genuine warmth and practicality. Within weeks, we saw meaningful changes: better organization, clearer planning, less resistance to starting work, and much stronger follow-through. She breaks tasks into manageable steps, teaches simple tools that actually stick, and coaches us as parents so we can reinforce skills at home. What stands out most is Roxanne's attunement—she listens, adapts in real time, and celebrates progress in a way that builds confidence. Our child feels understood and capable, and we finally have a roadmap that works. We're very grateful and highly recommend Roxanne to any family looking for smart, compassionate, evidence-based support.",
      author: "M. Bouvier"
    },
    {
      text: "Roxanne began working with our son this school year and has been wonderful. She goes beyond just working with him during their session together. She puts together week long game plans to tackle more complex projects as well as providing us with tips and resources that help 7 days a week, not just the one day she is present.",
      author: "R. Kinsey"
    }
  ];

  const renderStars = () => {
    return (
      <div className="stars">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="star">★</span>
        ))}
      </div>
    );
  };

  const handleCardClick = (testimonial: Testimonial) => {
    setSelectedTestimonial(testimonial);
  };

  const closeModal = () => {
    setSelectedTestimonial(null);
  };

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container">
        <h2>Testimonials</h2>
        <div className="testimonials-row">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`testimonial-card ${index === 2 ? 'lead' : ''}`}
              onClick={() => handleCardClick(testimonial)}
            >
              {renderStars()}
              <p className="testimonial-text">"{testimonial.text}"</p>
              {testimonial.author && (
                <p className="testimonial-author">— {testimonial.author}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      {selectedTestimonial && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            {renderStars()}
            <p className="modal-text">"{selectedTestimonial.text}"</p>
            {selectedTestimonial.author && (
              <p className="modal-author">— {selectedTestimonial.author}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
